// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__5mphd","products":"Search_products__GzJXY","header":"Search_header__V0zPE","goBack":"Search_goBack__ZwkOM","title":"Search_title__IxUks"};